import styled from 'styled-components';

export const Container = styled.div`
	h2 {
		text-align: left;
	}
`;
export const Title = styled.h1`
	background-color: white;
	color: #4d4d4d;
	font-size: 1em;
	font-weight: 100;
	text-transform: uppercase;
	padding: 2px 0 11px 0;
	-webkit-box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	-moz-box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);
	display: inline-block;
	width: 100%;
`;
export const BoxMaiores = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;
	min-height: 600px;

	margin-top: 30px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-cotistas-maiores.jpg');
	background-position: right center;
	background-size: cover;
	background-repeat: no-repeat;

	@media (max-width: 780px) {
		padding: 0;
		margin-top: 0;

		background-image: none;
		justify-content: end;
	}
`;
export const BoxSegmentacao = styled.div`
	display: flex;
	justify-content: center;

	min-height: 600px;

	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-cotistas-segmentacao-maos.png');
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;

	width: 100%;

`;
export const BoxMovimentacoes = styled.div`
	display: flex;
	justify-content: center;


	width: 100%;

	min-height: 420px;
`;
export const ContentMaiores = styled.div`
	width: 90%;
	max-width: 1141px;

	display: flex;
	justify-content: left;

	@media (max-width: 780px) {
		width: 100%;
	}
`;
export const ContentSegmentacao = styled.div`
	width: 90%;
	max-width: 1141px;
	min-height: 500px;

	h2 {
		color: var(--white);
		margin-bottom: 30px;
	}

	.SegmentacaoGrid {
		padding-top: 80px;
		padding-left: 80px;

		img {
			width: 100%;
		}
	}
	.SegmentacaoImg {
		display: flex;
		align-items: flex-end;
	}

	.SegmentacaoImg img {
		height: 90%;
	}

	@media (max-width: 780px) {
		width: 100%;

		.SegmentacaoImg {
			display: none;
		}

		.SegmentacaoGrid {
			background-image: none;
			background-color: var(--light-blue);

			display: unset;
			align-items: unset;

			padding: 30px 15px;

			overflow-x: scroll;
			overflow-y: hidden;

			> h2 {
				color: var(--white);
			}
		}
	}
`;
export const ContentMovimentacoes = styled.div`
	width: 90%;
	max-width: 1141px;

	border: var(--white) solid 1px;
	padding: 80px 0;

	h2 {
		color: var(--dark-blue);
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
		}

		strong {
			font-size: 14px;
			font-weight: normal;
			text-transform: none;
		}
	}

	@media (max-width: 780px) {
		padding: 30px 0px;

		overflow-x: scroll;
		overflow-y: hidden;

		h2 {
			flex-direction: column;

			strong {
				margin-top: 10px;
			}
		}
	}
`;
export const BlockMaiores = styled.div`
	background-color: var(--dark-blue);

	width: 675px;

	margin: -30px 0;
	padding: 40px;

	> h2 {
		color: var(--white);
	}

	@media (max-width: 780px) {
		width: 100%;

		margin: 0;
		padding: 30px 15px;

		overflow-x: scroll;
		overflow-y: hidden;
	}
`;
export const BlockSegmentacao = styled.div`
	width: 100%;

	background-color: var(--white);
	margin-bottom: 60px;

	@media (max-width: 780px) {
		background: transparent;

		height: 100%;
	}
`;
export const Tabela = styled.div`
	/* min-width: 600px; */
	width: 100%;
	height: 95%;
	min-height: 190px;
	max-height: 710px;

	margin-top: 20px;
	/* border: 1px solid var(--black); */

	@media (max-width: 780px) {
		height: 90%;
	}
`;
export const BoxCadastro = styled.div`
	width: 100%;
	min-height: 300px;
	background-image: linear-gradient(#022980, #001e62);
	display: flex;
	justify-content: center;
	position: relative;

	@media (max-width: 768px) {
		min-height: unset;
	}
`;
export const ContentCadastro = styled.div`
	min-height: 200px;
	height: 370px;

	width: 90%;
	max-width: 1141px;

	> div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		width: 60%;
		height: 100%;
		padding: 50px 40px;
		margin: -25px 0 35px 0;

		background-color: var(--light-blue);

		> h2 {
			color: var(--white);
		}

		> p {
			line-height: 1.5em;
			color: var(--white);

			font-size: 21px;
			font-weight: bold;
		}

		> div {
			width: 75%;

			margin: 40px 0 0 0;
			padding: 25px 30px;

			color: var(--white);
			border: 1px solid var(--dark-blue);
			background-color: var(--dark-blue);

			font-size: 20px;
			text-transform: uppercase;

			transition: all ease 0.2s;

			cursor: pointer;

			:hover {
				color: var(--light-blue) !important;
				border: 1px solid var(--white);
				background-color: var(--white);
			}

			> a {
				color: inherit;
			}
		}

		@media (max-width: 768px) {
			width: unset;
			margin: unset;
			padding: 30px;
		}
	}

	@media (max-width: 768px) {
		width: 100%;
	}
`;
export const ImageCadastro = styled.div`
	width: 35%;
	background-image: url('/asset-management/etf-commodities/images/commodities-btg-pactual-cadastre-se.jpg');
	background-size: cover;
	background-position: center bottom;
	position: absolute;
	top: 0;
	right: 0;
	height: 100%;

	@media (max-width: 768px) {
		display: none;
	}
`;

export const ImagemSegmentacaoLateral = styled.div`
	width: 320px;
	height: 320px;
	
	border-radius: 100%;
	margin: 50px 0 0 65px;
`;


export const HoraAtualizacaoMaioresCotistas = styled.div`

width: 100%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top:  -30px;

> h2 {
	min-width: 100px;
	color: white;
	font-size: 14px;
	align: center;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;

}

`;


export const HoraAtualizacaoSegmentacao = styled.div`

width: 100%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: -60px;

> h2 {
	min-width: 100px;
	color: darkblue;
	font-size: 14px;
	align: center;
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
}

`;

export const HoraAtualizacaoMaioresMovimentacoes = styled.div`

width: 100%;
display: flex;
justify-content: flex-end;
height:auto;
margin-top: -85px;

> h2 {
	min-width: 100px;
	color: darkblue;
	font-size: 14px;
	
}

img{
	width: unset;
	height:18px;
	z-index:0;
	margin-left: 5px;
	
}

`;